export // Funkcja sprawdzająca czy mamy zgodę na analytics
const hasAnalyticsConsent = () => {
	if (typeof window === "undefined" || !window.gtag) {
		return false;
	}

	try {
		// Znajdź wszystkie wpisy consent i weź ostatni (najnowszy)
		const consentItems = window.dataLayer?.filter((item) => {
			// Sprawdź czy to jest gtag consent call
			if (
				Array.isArray(item) ||
				(item && typeof item === "object" && item.length >= 3)
			) {
				// Format: gtag('consent', 'update'/'default', {...})
				return (
					item[0] === "consent" &&
					item[2]?.analytics_storage !== undefined
				);
			}

			// Sprawdź też tradycyjne eventy w dataLayer
			return (
				item?.event === "consent" &&
				item?.analytics_storage !== undefined
			);
		});

		if (!consentItems || consentItems.length === 0) {
			return false;
		}

		// Weź ostatni (najnowszy) wpis consent
		const latestConsent = consentItems[consentItems.length - 1];

		// Sprawdź czy w najnowszym wpisie analytics_storage jest "granted"
		let result;
		// Arguments object lub Array - oba mają numeryczne indeksy
		if (
			Array.isArray(latestConsent) ||
			latestConsent.length !== undefined
		) {
			result = latestConsent[2]?.analytics_storage === "granted";
		} else {
			result = latestConsent?.analytics_storage === "granted";
		}

		return result;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.warn("Error checking analytics consent:", error);
		return false;
	}
};
